<template>
   <div class="path-manage" style="padding:24px 24px 70px 24px;">
      <div style="height:60px;background:#fff;margin-bottom:16px;padding:16px 24px 0">
        <span style="color:rgba(51, 51, 51, 1);font-size:18px;font-weight:bold;">计费策略</span>
        <span style="color:rgba(153, 153, 153, 1);font-size:14px;margin:6px 0 0 24px">{{accountingStrategy.typeName}}
          <span v-if="accountingStrategy.type==2||accountingStrategy.type==3">：{{accountingStrategy.name}}（余量：{{accountingStrategy.surplus}}次，有效期：{{accountingStrategy.endTime}}）</span>
        </span>
        <span v-if="accountingStrategy.sign" style="color:#f5574e">请先选择计费策略</span>
        <a-button @click="changeAccounting " style="float:right;background:rgba(34, 215, 187, 1);border-color:rgba(34, 215, 187, 1);width:80px;" type="primary">
          修改
        </a-button>
      </div>
      <div class="path-manage-card1">
        <div class="path-manage-text" style="padding:16px 0 0 24px;">
          机器人列表
        </div>
        <a-divider style="margin:16px 0" />
        <div style="margin-top:24px;padding:0 24px 24px 24px">
            <a-row>
              <a-col :span="6">
                <div style="margin-bottom:5px;color:rgba(80, 80, 80, 1);font-size:14px;">名称查询：</div>
                <a-input
                  style="width:80%"
                  placeholder="通道名称/IP地址/注册号码"
                  v-model="keyword"
                />
              </a-col>
              <a-col :span="6">
                <div style="margin-bottom:5px;color:rgba(80, 80, 80, 1);font-size:14px;">项目名称：</div>
                <a-select
                style="width:200px;"
                  placeholder="请选择"
                  @change="handleSelectChange2"
                >
                  <a-select-option :title="item.name" :value="item.id" v-for="(item, index) in proList" :key="index">
                    {{item.name}}
                  </a-select-option>
                </a-select>
              </a-col>
              <a-col :span="6">
                <div style="margin-bottom:5px;color:rgba(80, 80, 80, 1);font-size:14px;">到期时间：</div>
                <a-range-picker
                  :locale="locale"
                  @change="changeTime"
                  :placeholder="[startTime, endTime]"
                  :showTime="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                  }"
                  format="YYYY-MM-DD"
                />
              </a-col>
              <a-col :span="6">
                <a-button style="float:right;background:rgba(34, 215, 187, 1);border-color:rgba(34, 215, 187, 1);margin-top:25px;width:80px;" type="primary" @click="queryData(1)">
                  查询
                </a-button>
                <a-button style="float:right;margin-right:14px;border-color:rgba(34, 215, 187, 1);color:rgba(34, 215, 187, 1);margin-top:25px;width:80px;" type="" @click="reset">
                  重置
                </a-button>
              </a-col>
            </a-row>
        </div>
      </div>
      <div class="path-manage-card2">
        <div>
          <span style="color:rgba(51, 51, 51, 1);font-size:16px">查询数量：</span>
          <span style="color:rgba(34, 215, 187, 1);font-size:16px;">{{data.length}}</span>
          <div style="display:inline-block;float:right">
            <a-button type="primary" style="background:rgba(34, 215, 187, 1);border-color:rgba(34, 215, 187, 1);width:80px;" @click="showModal">新建</a-button>
          </div>
        </div>
        <div style="clear:both"></div>
        <div class="path-manage-table">
          <a-locale-provider :locale="zhCN">
          <a-table 
            :row-selection="rowSelection" 
            :columns="columns" 
            :data-source="data" 
            :rowKey="record => record.id"
            :pagination="pagination"
          >
          </a-table>
          </a-locale-provider>
          <a-button @click="batchChange" v-if="changedPathIdList.length>0" type="primary" style="background:rgba(34, 215, 187, 1);border-color:rgba(34, 215, 187, 1);margin:0 0 0 16px;float:left;position:absolute;bottom:40px;left:0px;">前往批量修改</a-button>
          <a-button @click="submitOrder" v-if="changedPathIdList.length>0" type="primary" style="background:rgba(34, 215, 187, 1);border-color:rgba(34, 215, 187, 1);margin:0 0 0 16px;float:left;position:absolute;bottom:40px;left:132px;display:none">选择激活时间</a-button>
        </div>
      </div>
      <a-modal
        :mask-closable="true"
        title="新建通道"
        :visible="visibleNew"
        @ok="handleOk"
        @cancel="handleCancel"
        okText="确认" cancelText="取消"
      >
        <div style="margin:20px 0">
          <span style="float:left">通道名称：</span>
          <a-input placeholder="请输入通道名" v-model="pathName" style="width:400px"/>
        </div>
        <div style="margin-bottom:20px">
          <span>项目名称：</span>
          <a-select style="width:174px"
            placeholder="请选择项目"
            @change="handleSelectChange3"
            v-model="selectProId"
            :key="selectProId"
            :defaultValue='selectProId'
          >
            <a-select-option title="请选择" value=''>
              请选择
            </a-select-option>
            <a-select-option :title="item.name" :value="item.id"  v-for="(item, index) in proList" :key="index">
              {{item.name}}
            </a-select-option>
          </a-select>
        </div>
        <div>
          <span>通道数量：</span>
          <a-input-number style="width:120px" :min="0" :max="100" v-model="pathNum" @change='changeNum'/>
          <span v-if="showTip" style="color:rgba(244, 72, 20, 1);margin-left:24px">*最大支持批量新建100条</span>
        </div>
      </a-modal>
      <a-modal
        :mask-closable="true"
        title="批量修改"
        :visible="visibleChange"
        @ok="sureChange"
        @cancel="offChage"
        okText="确认" cancelText="取消"
      >
        <div style="margin:20px 0">
          <span style="float:left">通道名称：</span>
          <a-input placeholder="请输入通道名" v-model="changePathName" style="width:400px"/>
        </div>
        <div style="margin-bottom:20px">
          <span>项目名称：</span>
          <a-select style="width:174px"
            placeholder="请选择项目"
            @change="changeProId"
            v-model="lotProjectId"
            :key="lotProjectId"
            :defaultValue='lotProjectId'
          >
            <a-select-option title="请选择" value=''>
              请选择
            </a-select-option>
            <a-select-option title="空" value="-1">
              空
            </a-select-option>
            <a-select-option :title="item.name" :value="item.id"  v-for="(item, index) in proList" :key="index">
              {{item.name}}
            </a-select-option>
          </a-select>
        </div>
        <div>
          <span>修改数量：{{changedPathIdList.length}}</span>        
        </div>
      </a-modal>
      <a-modal
        title="请选择激活时间"
        :visible="timeModal"
        :footer="null"
        width='730px'
        @cancel="timeCancel"
      >
        <div id="time-select-modal">
          <div style="display:flex">
            <div style="width:70px;color:rgba(153, 153, 153, 1);font-size:14px">时间选择：</div>
            <div style="flex:1">
              <div class="box" v-for="(item, index) in packageList" :key='index' @click="chooseCurrentTime(item, index)" :class="{'active':currentTimeIndex==index}">
                <div style="color:rgba(153, 153, 153, 1);font-size:14px">
                  <span>{{item.name}}</span>
                </div>
                <div style="position:absolute;bottom:0px;right:0px;width:" v-if="currentTimeIndex==index">
                  <img style="width:20px;background:rgba(34, 215, 187, 1);border-radius:4px 0 0 4px" src="../../assets/img/yes.svg" alt="">
                </div>
              </div>
            </div>
          </div>
          <div style="display:flex;margin-top:32px">
            <div style="width:70px;color:rgba(153, 153, 153, 1);font-size:14px">总计：</div>
            <div style="flex:1">
              <div style="color:rgba(34, 215, 187, 1);font-size:18px">{{selectedPackage.price}}*{{changedPathIdList.length}}=￥{{selectedPackage.price*changedPathIdList.length}}</div>
              <div style="color:rgba(204, 204, 204, 1);font-size:14px">共计选择{{changedPathIdList.length}}个通道</div>
            </div>
          </div>
          <div style="font-size:14px;margin-top:24px;text-align:center">
            <span @click="timeSure" style="display:inline-block;width:80px;height:34px;line-height:34px;text-align:center;border-radius:4px;border:1px solid rgba(34, 215, 187, 1);color:#fff;background:rgba(34, 215, 187, 1);cursor:pointer">确认</span>
          </div>
        </div>
      </a-modal>
      <a-modal
        title="通道激活付款"
        :visible="payModal"
        :footer="null"
        width='540px'
        @cancel="payCancel"
      >
        <div>
          <div>
            <a-icon type="warning" style="color:rgba(255, 170, 0, 1);font-size:22px"/>
            <span style="color:rgba(80, 80, 80, 1);font-size:18px;margin-left:16px">您确认要激活吗？一旦激活即为付款</span>
          </div>
          <div style="margin-top:24px;">
            <span style="width:98px;color:rgba(51, 51, 51, 1);font-size:14px;display:inline-block">总计付款金额：</span>
            <span style="color:rgba(34, 215, 187, 1);font-size:18px;">￥{{selectedPackage.price*changedPathIdList.length}}</span>
          </div>
          <div style="margin-top:24px;">
            <span style="width:98px;color:rgba(51, 51, 51, 1);font-size:14px;display:inline-block">确认账户密码：</span>
            <a-input v-model="password" placeholder="请输入密码" style="width:380px;height:40px;" type="password">
              <a-icon slot="prefix" type="lock" />
            </a-input>
          </div>
          <div style="font-size:14px;margin-top:24px;text-align:right">
            <span @click="payCancel" style="display:inline-block;width:80px;height:34px;line-height:34px;text-align:center;border-radius:4px;border:1px solid rgba(34, 215, 187, 1);color:rgba(34, 215, 187, 1);margin-right:16px;cursor:pointer">取消</span>
            <span @click="activateChannel" style="display:inline-block;width:80px;height:34px;line-height:34px;text-align:center;border-radius:4px;border:1px solid rgba(34, 215, 187, 1);color:#fff;background:rgba(34, 215, 187, 1);cursor:pointer">确认</span>
          </div>
        </div>
      </a-modal>
      <a-alert
        v-if="payState=='success'"
        style="position:fixed;left:50%;width:324px;top:30%;height:106px;margin-left:-162px;margin-top:-70px;"
        message="付款成功"
        description="您可在“我的账户”中查看此消费记录"
        type="success"
        show-icon
      />
      <a-alert
        v-if="payState=='error'"
        style="position:fixed;left:50%;width:324px;top:30%;height:106px;margin-left:-162px;margin-top:-70px;"
        message="付款失败"
        :description="payErrorDes"
        type="error"
        show-icon
      />
      <a-modal
        :mask-closable="true"
        title="修改计费策略"
        :visible="accountingModal"
        @ok="changeCharge"
        @cancel="cancelCharge"
        okText="确认" cancelText="取消"
      >
        <div style="color:rgba(80, 80, 80, 1);font-size:14px;height:77px">
          <div>
            <span>计费策略：</span>
            <a-radio-group name="radioGroup" v-model="accountingWay" @change="changeStrategy">
              <a-radio :value="1">
                时效性
              </a-radio>
              <a-radio :value="2">
                按次
              </a-radio>
              <a-radio :value="3">
                按天
              </a-radio>
            </a-radio-group>
          </div>
          <div style="margin-top:24px;display:flex;" v-if="accountingWay==2||accountingWay==3">
            <span style="display:inline-block;width:70px;float:left;margin-top:4px;">选资源包：</span>
            <a-select default-value="" placeholder='请选择' style="flex:1" v-model="sourcePackage">
              <a-select-option :value="item.value" v-for="(item,index) in sourceList" :key='index'>
                {{item.name}}
              </a-select-option>
            </a-select>
          </div>
        </div>
      </a-modal>
    </div>
</template>
<script>
  import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
  import zhCN from 'ant-design-vue/es/locale-provider/zh_CN';
  import moment from 'moment';
  const columns = [
    {
      title: '机器人昵称',
      dataIndex: 'name',
    },
    {
      title: '通道号码',
      dataIndex: 'code',
    },
    {
      title: '项目名称',
      dataIndex: 'project',
    },
    {
      title: '到期时间',
      dataIndex: 'limitDate',
      defaultSortOrder: 'descend',
      sorter: (a, b) => (new Date(a.limitDate)).getTime() - (new Date(b.limitDate)).getTime()
    },
  ];
  export default {
    name: 'pathManage',
    props: {
      msg: String
    },
    data() {
      return {
        locale,
        data: [],
        keyword: '',
        status: '',
        projectId: '',
        proList: [],
        visibleNew: false,
        pathId: '',
        pathName: '',
        selectProId: '',
        total: 0,
        columns,
        editingKey: '',
        projectName: '',
        newProjectId: '',
        pathNum: 1,
        visibleChange: false,
        changePathName:'',
        changedPathIdList: [],
        lotProjectId: '',
        showTip: false,
        payModal: false,
        timeModal: false,
        currentTimeIndex: 1,
        payState: '',
        selectedPackage: {},
        payTotalPrice: 0,
        packageList: [],
        password: '',
        startTime: '开始时间',
        endTime: '结束时间',
        pagination: {
          total: 0,
          pageSize: 10,//每页中显示10条数据
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"]
        },
        zhCN,
        accountingModal: false,
        accountingWay: 1,
        sourcePackage: undefined,
        accountingStrategy: {
          type: '',
          typeName: '',
          name: '',
          surplus: '',
          endTime: '',
          sign: false
        },
        sourceList: []
      };
    },
    methods: {
      moment,
      changeNum() {
        if(this.pathNum > 100){
          this.showTip = true
          this.pathNum = 100
        }else{
          this.showTip = false
        }
      },
      handleSelectChange1(value) {
        this.status = value
      },
      handleSelectChange2(value) {
        this.projectId = value
      },
      queryData(type) {
        if(type ==1){
          this.current = 1
        }
        this.axios(
          {
            method:'get',
            url:'/api/channel/list',
            params: {
              keyword: this.keyword,
              status: this.status,
              projectId: this.projectId,
              minLimitDate: this.startTime=='开始时间'?'':this.startTime,
              maxLimitDate: this.endTime=='结束时间'?'':this.endTime
            }
          }
        )
        .then(response=> {
          if(response.data.code == 0){
            this.changedPathIdList = []
            this.data = response.data.data
            this.total = response.data.data.total
          }else{
            this.$message.error(response.data.message);
          }
        })
        .catch(error=> {
          console.log(error)
        })
      },
      reset() {
        this.current = 1
        this.size = 10
        this.keyword = ''
        this.status = ''
        this.projectId = ''
        this.queryData(1)
      },
      showModal() {
        this.visibleNew = true;
      },
      handleOk() {
        this.visibleNew = false;
        this.pathId = ''
        this.createChangePath()
      },
      createChangePath() {
        this.axios.post('/api/channel/add', {
          count: this.pathNum,
          name: this.pathName,
          projectId: this.selectProId
        })
        .then(response=> {
          if(response.data.code == 0){
            this.pathName = ''
            this.projectId = ''
            this.pathNum = 1
            this.pathName = ''
            this.selectProId = ''
            this.$message.success('新建成功');
            this.queryData(2)
          }else{
            this.$message.error(response.data.message);
          }
        })
        .catch(error=> {
          console.log(error)
        })
      },
      handleCancel() {
        this.visibleNew = false;
      },
      handleSelectChange3(value) {
        this.selectProId = value
      },
      operation(value) {
        value.judge = true
      },
      querySelectList() {
        this.axios.get('/api/dropdown/project')
        .then(response=> {
          if(response.data.code == 0){
            this.proList = response.data.data
          }else{
            this.$message.error(response.data.message);
          }
        })
        .catch(error=> {
          console.log(error)
        })
      },
      handleChange(value, key, column) {
        const newData = [...this.data];
        const target = newData.filter(item => key === item.id)[0];
        if (target) {
          target[column] = value;
          this.data = newData;
        }
      },
      changeProjectId(value) {
        this.newProjectId = value
      },
      sureChange() {
        this.visibleChange = false;
        this.axios.post('/api/channel/update/batch', {
          idList: this.changedPathIdList,
          name: this.changePathName,
          projectId: this.lotProjectId
        })
        .then(response=> {
          if(response.data.code == 0){
            this.changePathName = ''
            this.lotProjectId = ''
            this.$message.success('修改成功');
            this.queryData(2)
          }else{
            this.$message.error(response.data.message);
          }
        })
        .catch(error=> {
          console.log(error)
        })
      },
      offChage() {
        this.visibleChange = false;
      },
      changeProId(value) {
        this.lotProjectId = value
      },
      batchChange() {
        this.visibleChange = true
      },
      submitOrder() {
        this.timeModal = true;
      },
      payCancel() {
        this.payModal = false;
      },
      paySure() {
        this.payState = 'success'
        setTimeout(()=>{
          this.payState = ''
        },1500)
      },
      payFalse() {
        this.payState = 'error'
        setTimeout(()=>{
          this.payState = ''
        },1500)
      },
      timeCancel() {
        this.timeModal = false;
      },
      timeSure() {
        this.timeModal = false;
        this.payModal = true;
        this.payTotalPrice = this.selectedPackage.totalPrice*this.changedPathIdList.length
      },
      chooseCurrentTime(item, index) {
        this.currentTimeIndex = index
        this.selectedPackage = item
      },
      queryPackageList() {
        this.axios(
          {
            method:'get',
            url:'/api/channel/price/list',
          }
        )
        .then(response=> {
          if(response.data.code == 0){
            this.packageList = response.data.data
            this.selectedPackage = this.packageList[1]
          }else{
            this.$message.error(response.data.message);
          }
        })
        .catch(error=> {
          console.log(error)
        })
      },
      activateChannel() {
        this.payModal = false;
        this.axios.post('/api/channel/active', {
          idList: this.changedPathIdList,
          priceId: this.selectedPackage.id,
          password: this.password
        })
        .then(response=> {
          if(response.data.code == 0){
              this.paySure()
          }else{
            this.payErrorDes = response.data.message
            this.payFalse()          
          }
        })
        .catch(error=> {
            console.log(error)
        })
      },
      getCurrentDate(format) {
        var now = new Date();
        var year = now.getFullYear(); //得到年份
        var month = now.getMonth();//得到月份
        var date = now.getDate();//得到日期
        month = month + 1;
        if (month < 10) month = "0" + month;
        if (date < 10) date = "0" + date;
        var time = "";
        //开始时间
        if(format==1){
            
            time = year + "-" + month + "-" + date
        }
        //结束时间
        else if(format==2){
            var date1 = new Date();
            var date2 = new Date(date1);
            date2.setDate(date1.getDate() + 7);
            time = `${date2.getFullYear()}-${date2.getMonth() + 1<10?`0${date2.getMonth() + 1}`:date2.getMonth() + 1}-${date2.getDate()}`;
        }
        return time;
      },
      changeTime(date, dateString) {
        this.startTime = dateString[0]
        this.endTime = dateString[1]
      },
      changeAccounting() {
        this.accountingModal = true
      },
      changeCharge() {
        if(this.accountingWay==1){
          this.accountingModal = false
          this.carryCharge()
        }else{
          if(this.sourcePackage==undefined){
            this.$message.error('请选择资源包')
          }else{
            this.accountingModal = false
            this.carryCharge()
          }
        }
      },
      carryCharge() {
        this.axios.post('/api/intelligence/changeAccountingStrategy', {
          type: this.accountingWay,
          resourcePackageId: this.sourcePackage,
        })
        .then(response=> {
          if(response.data.code == 0){
            this.$message.success('切换成功')
            this.queryAccountingStrategy()
            this.queryData(1)
          }else{
            this.$message.error(response.data.message)     
          }
        })
        .catch(error=> {
          console.log(error)
        })
      },
      cancelCharge() {
        this.accountingModal = false
        this.sourcePackage = undefined
        this.accountingWay = 1
      },
      changeStrategy(e) {
        this.accountingWay = e.target.value
        this.axios(
          {
            method:'get',
            url:'/api/intelligence/queryResourcePackageSelect',
            params: {
              type: this.accountingWay
            }
          }
        )
        .then(response=> {
          if(response.data.code == 0){
            this.sourceList = response.data.data
            this.sourcePackage = undefined
          }else{
            this.$message.error(response.data.message);
          }
        })
        .catch(error=> {
          console.log(error)
        })
      },
      queryAccountingStrategy() {
        this.axios(
          {
            method:'get',
            url:'/api/intelligence/accountingStrategy',
          }
        )
        .then(response=> {
          if(response.data.code == 0){
            if(response.data.data != null){
              this.accountingStrategy.endTime = response.data.data.endTime
              this.accountingStrategy.name = response.data.data.name
              this.accountingStrategy.surplus = response.data.data.surplus
              this.accountingStrategy.type = response.data.data.type
              this.accountingStrategy.typeName = response.data.data.typeName
              this.accountingStrategy.sign = false
            }else{
              this.accountingStrategy.sign = true
            }
          }else{
            this.$message.error(response.data.message);
          }
        })
        .catch(error=> {
          console.log(error)
        })
      },
    },
    computed: {
      rowSelection() {
        return {
          onChange: (selectedRowKeys, selectedRows) => {
            this.changedPathIdList = []
            selectedRows.map((item)=>{
              this.changedPathIdList.push(item.id)
            })
          },
        };
      },
    },
    mounted: function() {
      this.sessionData('set','leftNavItem','pathManage');
      if(this.$route.query.num != undefined && this.$route.query.num != 0){
        this.startTime = this.getCurrentDate(1)
        this.endTime = this.getCurrentDate(2)
      }
      this.querySelectList()
      this.queryData(1)
      this.queryPackageList()
      this.queryAccountingStrategy()
    }
  }
</script>
  <style lang="less" >
    .path-manage{
      width: 100%;
      // height: 100%;
      .path-manage-text{
        font-size: 18px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
      .editable-row-operations a {
        margin-right: 8px;
      }
      .path-manage-card1{
        background: #fff;
        height: 164px;
      }
      .path-manage-card2{
        margin-top: 24px;
        background: #fff;
        padding: 24px 24px 44px;
        margin-bottom: 6px;
        .path-manage-table{
          padding-bottom: 24px;
          margin-top:24px;
          position: relative;
          td{
            padding-top: 0px !important;
            padding-bottom: 0px !important;
            height: 48px !important;
            line-height: 48px !important;
          }
          th{
            height: 48px !important;
            line-height: 48px !important;
            padding-top: 0px !important;
            padding-bottom: 0px !important;
            background: rgba(240, 240, 240, 1) !important;
          }
        }
      }
    }
    #time-select-modal{
      div.box{
        width:180px;
        height:90px;
        display:inline-block;
        padding:20px 24px;
        border:1px solid rgba(238, 238, 238, 1);
        cursor:pointer;
        margin-right:24px;
        margin-bottom:20px;
        position:relative;
      }
      div.active{
        border:1px solid rgba(34, 215, 187, 1);
        box-shadow: rgba(34, 215, 187, 1) solid 1px;
      }
    }
  </style>